import React, { useRef } from 'react'
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { Context } from '../../App';
import { useContext, useState, useEffect } from 'react';
import { RiMenuUnfoldLine } from "react-icons/ri";
import { RiMenuFoldLine } from "react-icons/ri";
import { IoDocumentTextOutline } from "react-icons/io5";
import { LuUserCheck2 } from "react-icons/lu";
import saycryptLogo from "../../assets/img/Saycrypt_Icon_W.png"
import { CiChat1, CiChat2, CiGrid41 } from "react-icons/ci";
import { motion } from "framer-motion";

import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { LiaUserEditSolid } from "react-icons/lia";
import TabsAnimation from '../animations/TabsAnimation';
import useOutsideCloser from '../../custom hooks/clickOutsideCloser';



function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies, setCookie] = useCookies(['GuruAccessKey']);

  const {
    showUsersContext,
    showMediaContext, } = useContext(Context);

  const [showUsers, setShowUsers] = showUsersContext;
  const [showMedia, setShowMedia] = showMediaContext;

  const adminModewTabRef = useRef(null);
  const [openWrapperMode, setOpenWrapperMode] = useState(false);
  useOutsideCloser(adminModewTabRef, setOpenWrapperMode);

  const modeSelectionTab = [
    {
      name: "Chats",
      icon: <CiChat1 className="w-full h-full" />,
      navigate: "/G"
    },
    {
      name: "Notes",
      icon: <CiChat2 className="w-full h-full" />,
      navigate: "/notes"
    },
  ]
  const [currModeSelectionTab, setCurrModeSelectionTab] = useState(
    location.pathname.split("/")[1] === "notes" ? 1 : location.pathname.split("/")[1] === "G" ? 0 : -1);

  const adminModeSelcTab = [
    {
      name: "Add User",
      icon: <AiOutlineUserAdd className="w-full h-full" />,
      navigate: "/GURU/add-user",
      id: "add-user",
    },
    {
      name: "Manage Users",
      icon: <LiaUserEditSolid className="w-full h-full" />,
      navigate: "/GURU/manage-users",
      id: "manage-users",
    },
    {
      name: "Add Group",
      icon: <AiOutlineUsergroupAdd className="w-full h-full" />,
      navigate: "/GURU/add-group",
      id: "add-group",
    },
    {
      name: "Manage Groups",
      icon: <LiaUserEditSolid className="w-full h-full" />,
      navigate: "/GURU/manage-groups",
      id: "manage-groups",
    },
    {
      name: "Add Individuals",
      icon: <AiOutlineUsergroupAdd className="w-full h-full" />,
      navigate: "/GURU/add-individual",
      id: "add-individual",
    },
    {
      name: "Manage Individuals",
      icon: <LiaUserEditSolid className="w-full h-full" />,
      navigate: "/GURU/manage-individuals",
      id: "manage-individuals",
    },
    {
      name: "Manage Requests",
      icon: <LuUserCheck2 className="w-full h-full" />,
      navigate: "/GURU/manage-requests",
      id: "manage-requests",
    },
  ]
  const currPage = location.pathname.split("/")[2];
  const [currAdminModeSelcTab, setCurrAdminModeSelcTab] = useState(
    currPage === "add-user" ? 0 : currPage === "manage-users" ? 1 : currPage === "add-group" ? 2 : currPage === "manage-groups" ? 3 : -1);

  useEffect(() => {
    const currPage = location.pathname.split("/")[2];
    setCurrModeSelectionTab(
      location.pathname.split("/")[1] === "notes" ? 1 : location.pathname.split("/")[1] === "G" ? 0 : -1)

    setCurrAdminModeSelcTab(currPage === "add-user" ? 0 : currPage === "manage-users" ? 1 : currPage === "add-group" ? 2 : currPage === "manage-groups" ? 3 : currPage === "add-individual" ? 4 : currPage === "manage-individuals" ? 5 : currPage === "manage-requests" ? 6 : -1)
  }, [location.pathname])


  if (location.pathname.split("/")[1] !== "signin" && location.pathname.split("/")[1] !== "Request-to-Let-Me-In")
    return (
      <div className='relative h-[50px] w-full bg-headPrimary flex items-center justify-center ' >

        <div
          onClick={() => (setShowUsers((prev) => !prev))}
          className="absolute left-3.5 md:left-4 top-0 bottom-0 my-auto h-fit cursor-pointer ">
          {showUsers ? <RiMenuFoldLine key={"leftMenuClose"} className='h-5 w-5 text-white' />
            : <RiMenuUnfoldLine key={"leftMenuOpen"} className='h-5 w-5 text-white' />
          }
        </div>

        {/* <div className="w-"> */}

        <div className="w-fit p-[3px] rounded flex items-center justify-between gap-1 absolute left-[calc(25vw-53px)] lg:left-[4rem] top-0 bottom-0 my-auto h-fit bg-white">
          {
            modeSelectionTab.map((item, i) => (
              <div
                key={item.name}
                onClick={() => {
                  setCurrModeSelectionTab(i);
                  navigate(item.navigate);
                  if (cookies.GuruAccessKey === "1q2w3e4r") {
                    localStorage.setItem('uid', "SUPREME");
                    localStorage.setItem("displayName", "SUPREME");
                  }
                }}
                className={`text-xs md:text-sm px-1 md:px-2 relative cursor-pointer flex items-center justify-start btn-primary min-w-[45px] md:min-w-[60px] 
              ${currModeSelectionTab === i ? " font-bold text-white" : "hover:bg-lightPrimary"}`} >

                {currModeSelectionTab === i && (
                  <TabsAnimation layoutId={"bubble"} />
                )}

                <div className="w-4 h-4 md:w-4 md:h-4 mr-1 z-20">{item.icon}</div>

                <div className="z-20">{item.name}</div>
              </div>
            ))
          }
        </div>
        {/* </div> */}

        <div
          onClick={() => { navigate('/G') }}
          className="text-white font-semibold cursor-pointer hover:font-bold transition-all duration-100">
          {/* SAYCRYPT */}
          <img src={saycryptLogo} alt="logo" width={38} />
        </div>

        {cookies.GuruAccessKey === "1q2w3e4r" &&
          <>{window.innerWidth < 100000 ?
            <div ref={adminModewTabRef}
              onMouseEnter={() => setOpenWrapperMode(true)}
              onMouseLeave={() => setOpenWrapperMode(false)}
              className="w-fit p-[3px] rounded absolute right-[calc(25vw-56px)] lg:right-[4rem] top-0 bottom-0 my-auto h-fit bg-white min-w-[130px] md:min-w-[145px]">
              <div
                onClick={() => setOpenWrapperMode((prev) => !prev)}
                className={`text-xs md:text-sm px-1 py0.5 relative cursor-pointer flex items-center justify-start btn-primary transition-all font-bold  
              ${adminModeSelcTab.map((item) => item.id).includes(currPage) ? "bg-headPrimary text-white" : "bg-lightPriamry text-gray-400"}`}>
                <div className="w-3 h-3 md:w-4 md:h-4 mr-0.5 md:mr-1 z-[49]">
                  {
                currAdminModeSelcTab === -1 ?
                <CiGrid41 className='w-full h-full' /> :
                adminModeSelcTab[currAdminModeSelcTab]?.icon}</div>

                <div className=" z-[49]">{currAdminModeSelcTab === -1 ? "Manage" : adminModeSelcTab[currAdminModeSelcTab]?.name}</div>
              </div>

              {/* ---------------MENU DROPDOWN ------------ */}
              <div style={{ "position": "revert-layer", "zIndex": 46 }}
                className={`top-7 left-0 min-w-[130px] md:min-w-[145px] absolute z-40 origin-top transition-all duration-200 ease-in-out ${openWrapperMode ? "scale-100" : "scale-0"}`}
              >
                <div
                  className={`grid grid-cols-1 gap-2 p-1 rounded border-gray-600 border bg-white shadow-md dark:!bg-navy-800 dark:text-white dark:shadow-none`}>

                  {adminModeSelcTab.map((item, i) => (
                    <div
                      key={item.name}
                      onClick={() => { setOpenWrapperMode(false); setCurrAdminModeSelcTab(i); navigate(item.navigate) }}
                      className={`text-xs md:text-sm px-1 py-0.5 rounded relative cursor-pointer flex items-center justify-start btn-primary min-w-[120px] transition-all 
              ${currAdminModeSelcTab === i ? "font-bold text-white" : "hover:bg-lightPrimary"}`} >

                      {currAdminModeSelcTab === i && (
                        <TabsAnimation layoutId={"bubble"} />
                      )}

                      <div className="w-3 h-3 md:w-4 md:h-4 mr-0.5 md:mr-1 z-20">{item.icon}</div>

                      <div className="z-20">{item.name}</div>
                    </div>
                  ))
                  }
                </div>
              </div>
            </div>
            :
            <div className="w-fit p-[3px] rounded flex items-center justify-between gap-1 absolute right-[4rem] top-0 bottom-0 my-auto h-fit bg-white">
              {adminModeSelcTab.map((item, i) => (
                <div
                  key={item.name}
                  onClick={() => { setCurrAdminModeSelcTab(i); navigate(item.navigate) }}
                  className={`text-sm px-2 relative cursor-pointer flex items-center justify-start btn-primary min-w-[60px] transition-all 
              ${currAdminModeSelcTab === i ? "font-bold text-white" : "hover:bg-lightPrimary"}`} >

                  {currAdminModeSelcTab === i && (
                    <TabsAnimation layoutId={"bubble"} />
                  )}

                  <div className="w-4 h-4 mr-1 z-20">{item.icon}</div>

                  <div className="z-20">{item.name}</div>
                </div>
              ))
              }
            </div>

          }
          </>
        }

        <div
          onClick={() => (setShowMedia((prev) => !prev))}
          className="absolute right-3.5 md:right-4 top-0 bottom-0 my-auto h-fit cursor-pointer ">
          {showMedia ? <RiMenuUnfoldLine key={"rightMenuClose"} className='h-5 w-5 text-white' />
            : <RiMenuFoldLine key={"rightMenuClose"} className='h-5 w-5 text-white' />
          }
        </div>
      </div>
    )
  else
    return (<></>)
}

export default Navbar